const setClasses = () => {
  if (
    /iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  )
    document.documentElement.classList.add('ios')

  document.documentElement.classList.add(
    'ontouchstart' in window || navigator.maxTouchPoints || navigator.msMaxTouchPoints
    ? 'touch' : 'no-touch'
  )
}

// don't let errors stop script
setTimeout(setClasses)
